import { CampaignToken } from '../types';

export function urlWithToken(url: string, token: CampaignToken): URL {
  const newUrl = new URL(url);
  newUrl.searchParams.append('jct', token);

  return newUrl;
}
